import * as React from 'react'

export const IconSpeedy = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13rem"
      height="10rem"
      viewBox="0 0 260 80"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <defs>
        <style>{'.fil0{fill:#43494d}'}</style>
      </defs>
      <g id="Layer_x0020_1">
        <g id="_432080904">
          <path
            id="_208982904"
            className="fil0"
            d="M218.063 18.809h7.414V57.79a51.633 51.633 0 01-10.966 1.25c-8.783 0-15.742-3.924-16.01-14.29.14-5.205 2.032-8.792 5.125-11.27 4.694-3.247 9.527-3.504 14.437-2.085V18.809zm0 19.093c-2.48-1.264-6.678-1.067-8.41-.033-2.367 1.288-3.501 3.523-3.624 6.583.038 3.719 1.421 6.244 4.148 7.576 2.353.892 5.199.988 7.886.336V37.902z"
          />
          <path
            id="_208983120"
            className="fil0"
            d="M125.391 58.599c8.542 0 15.44-4.178 15.393-14.523.146-10.242-7.538-14.32-16.23-13.848-4.06.256-7.369 1.246-10.465 2.332v36.47h7.38V37.373c3.32-.777 6.424-.848 9.057.639 1.95 1.409 3.133 3.713 2.957 6.735-.47 5.36-3.83 7.267-8.092 7.426v6.425z"
          />
          <path
            id="_208982832"
            className="fil0"
            d="M156.077 30.07c10.187-.084 12.92 6.114 12.537 17.615h-18.086c.936 5.686 6.577 7.307 16.51 2.809v6.782c-15.86 4.838-23.326.185-23.84-12.331 0-9.85 4.318-14.816 12.879-14.876zm.176 6.517c3.37.225 4.508 1.731 4.893 5.275h-10.618c.492-2.924 1.673-5.382 5.725-5.275z"
          />
          <path
            id="_432081024"
            className="fil0"
            d="M183.726 30.194c10.187-.083 12.92 6.114 12.537 17.615h-18.086c.936 5.686 6.577 7.307 16.51 2.809V57.4c-15.86 4.838-23.326.185-23.84-12.331 0-9.85 4.318-14.816 12.879-14.875zm.176 6.517c3.37.225 4.508 1.731 4.893 5.275h-10.618c.492-2.923 1.673-5.381 5.725-5.275z"
          />
          <path
            id="_432081120"
            className="fil0"
            d="M100.828 30.194c3.188-.024 5.987.733 8.394 2.27v6.638c-4.287-3.343-10.908-4.161-11.465-.877-1.109 6.046 14.216.04 13.086 13.127-.76 5.595-5.045 7.518-10.6 7.69-3.409.1-6.553-.486-9.31-2.077v-6.833c4.746 3.149 11.608 4.24 12.58.977 1.327-5.499-13.63-1.254-12.806-12.154.12-5.458 3.494-8.379 10.121-8.761z"
          />
          <path
            id="_432080952"
            className="fil0"
            d="M227.523 30.708h7.76l6.052 16.977 5.954-16.977H255l-13.177 38.311h-7.809l3.29-9.978z"
          />
        </g>
        <path
          d="M37.18 2.503h-.026c-.419.003-.836.092-1.153.267L6.626 18.78l32.908 19.157c.304.167.537.563.537.92v27.946c0 .352-.251.754-.559.918l-1.77.984c-.148.078-.335.12-.53.12h-.035a1.162 1.162 0 01-.565-.12l-1.776-.984c-.303-.16-.55-.565-.55-.918l.001-24.912c-.016-.183-.15-.405-.295-.49L5 24.525v33.057c0 .74.52 1.651 1.16 2.025l29.86 17.61c.316.186.733.279 1.15.28h.01c.42-.002.84-.09 1.158-.28l29.865-17.61c.636-.377 1.156-1.285 1.155-2.025V24.525L49.71 35.972c-.303.177-.778.163-1.074-.02l-1.741-1.034a1.156 1.156 0 01-.37-.398l-.018-.03a1.16 1.16 0 01-.18-.549l-.045-2.03c-.013-.342.212-.759.516-.936L67.731 18.78 38.357 2.77c-.324-.18-.75-.266-1.177-.267z"
          fill="#d82629"
        />
      </g>
    </svg>
  )
}
